import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '@/store/api/baseQuery';
import { setLoading } from '@/store/reducers/authSlice';

export interface ProfileResponse {
  firstName: string;
  lastName: string;
  email: string;
}

export const profileApi = createApi({
  reducerPath: 'profileApi',

  baseQuery,

  tagTypes: ['Profile'],

  endpoints: (builder) => ({
    fetchProfile: builder.query<ProfileResponse, void>({
      query: () => ({
        url: '/api/user/me/profile',
        method: 'GET',
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        dispatch(setLoading(true));
        try {
          await queryFulfilled;
          dispatch(setLoading(false));
        } catch {
          dispatch(setLoading(false));
        }
      },
      providesTags: ['Profile'],
    }),
  }),
});

export const {
  useFetchProfileQuery,
  useLazyFetchProfileQuery,
} = profileApi;